import LayoutContext from "../context/ProjectLayout";
import { useContext } from "react";

export default () => useContext(LayoutContext);